import {
  PapiAuthenticationProvider, PropsFromState, PropsFromActions,
} from "../Api/PapiClient";
import { AppState } from "../Store/RootReducer";
import { connect } from "react-redux";
import { saveTradingAccounts, saveClientAccount, saveLinkedTradingAccounts, saveActiveTradingAccount } from "../Platform/State";
import { TradingAccount, Account } from "swan-public-api-client";

const mapStatetoProps = (state: AppState): PropsFromState => {
  const { token } = state.session;
  return {
    existingToken: token,
    activeTradingAccount: state.activeTradingAccount.account };
};

const mapDispatchToProps = (dispatch: any): PropsFromActions => ({
  setTradingAccounts: (tradingAccounts: TradingAccount[]) => dispatch(saveTradingAccounts(tradingAccounts)),
  setLinkedTradingAccounts: (linkedTradingAccounts: TradingAccount[]) => dispatch(saveLinkedTradingAccounts(linkedTradingAccounts)),
  setClientAccount: (account: Account) => dispatch(saveClientAccount(account)),
  setActiveTradingAccount: (activeTradingAccount: TradingAccount | undefined) => dispatch(saveActiveTradingAccount(activeTradingAccount))
})

export const PapiAuthenticationProviderWithSessionState = connect(
  mapStatetoProps,
  mapDispatchToProps
)(PapiAuthenticationProvider);
